import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const ContentShowcase = () => {
  const items = [
    {
      title: "Digital Marketing",
      imgSrc:
        "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/mktng320-business-owner-celebrating-with-launch-of-website-1-2048x1498_png.webp?v=1763929540",
      description: "Performance-driven strategies to scale your business online.",
      route: "/web-design",
    },
    {
      title: "Brand Promotion",
      imgSrc:
        "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Businesswomen-she-economy-girl-power-girl-boss-2048x1348.png?v=1763929540",
      description: "Create a strong, memorable brand presence across platforms.",
      route: "/branding",
    },
    {
      title: "Content Creation",
      imgSrc:
        "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Article-74-creative-logos-01_png.webp?v=1763929540",
      description: "High-quality content that converts visitors into customers.",
      route: "/marketing",
    },
  ];

  return (
    <ShowcaseSection>
      <SectionLabel>Other Services</SectionLabel>

      <ShowcaseGrid>
        {items.map((item, index) => (
          <Card to={item.route} key={index}>
            <CardInner>
              <CardImage src={item.imgSrc} alt={item.title} />

              <Overlay />

              <CardTitle>{item.title}</CardTitle>

              <BottomContent>
                <CardDescription>{item.description}</CardDescription>
                <ViewMoreButton>View More</ViewMoreButton>
              </BottomContent>
            </CardInner>
          </Card>
        ))}
      </ShowcaseGrid>
    </ShowcaseSection>
  );
};
const ShowcaseSection = styled.section`
  padding: 80px 20px;
  // background: #fafafa;
`;

const SectionLabel = styled.h2`
  text-align: center;
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 60px;
  background: linear-gradient(135deg, #ff8a3d, #d55bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 40px;
  }
`;

const ShowcaseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  max-width: 1200px;
  margin: auto;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
const Card = styled(Link)`
  text-decoration: none;
  color: inherit;
  border-radius: 22px;
  overflow: hidden;
  height: 340px;
  background: #fff;
  box-shadow: 0 14px 40px rgba(255, 245, 238, 0.6); // soft #fff5ee shadow
  transition: transform 0.4s ease, box-shadow 0.4s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 
      0 20px 40px rgba(255, 245, 238, 0.7),   // #fff5ee
      0 28px 60px rgba(247, 242, 255, 0.6);   // #f7f2ff
  }
`;


const CardInner = styled.div`
  position: relative;
  height: 100%;
`;
const CardImage = styled.img`
  width: 100%;
  height: 65%;
  object-fit: cover;
  transition: transform 0.6s ease;

  ${Card}:hover & {
    transform: scale(1.08);
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0)
  );
  opacity: 0;
  transition: opacity 0.4s ease;

  ${Card}:hover & {
    opacity: 1;
  }
`;
const CardTitle = styled.h3`
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 20px;
  font-weight: 700;
  color: #111;
  transition: all 0.4s ease;

  ${Card}:hover & {
    bottom: 110px;
    color: #fff;
  }
`;

const BottomContent = styled.div`
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  width: 85%;
  text-align: center;
  opacity: 0;
  transition: opacity 0.4s ease 0.1s;

  ${Card}:hover & {
    opacity: 1;
  }
`;

const CardDescription = styled.p`
  font-size: 15px;
  color: #eee;
  margin-bottom: 14px;
`;
const ViewMoreButton = styled.div`
  padding: 12px 0;
  border-radius: 30px;
  background: linear-gradient(45deg, #ff8a3d, #d55bff);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  transition: transform 0.3s ease;

  &:active {
    transform: scale(0.95);
  }
`;
export default ContentShowcase;